import React from "react";
import { ArrowDownIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { flowSteps, images } from "../../data/content";
const cycle = ["They find a recipe.", "They try it.", "They look for another recipe.", "They buy more ingredients.", "They experiment.", "They get confused."];
export function Author() {
  return <section className="w-full bg-paper px-5 py-16 md:py-24" data-id="element-73" data-mp="1ronlvt0awsq2">
      <div className="mx-auto grid max-w-5xl gap-10 md:grid-cols-[0.9fr_1.1fr] md:items-start md:gap-14" data-id="element-74" data-mp="25gk6lbzn40cf">
        <div className="md:sticky md:top-8" data-id="element-75" data-mp="20h8rs8iu34xh">
          <img src={images.author} alt="Nancy Uribe, creator of The Aroma Lab, testing an aroma blotter in her studio" className="aspect-[4/5] w-full rounded-3xl object-cover object-top shadow-[0_24px_50px_-24px_rgba(30,50,25,0.45)]" data-id="element-76" data-mp="20kmr17w7ay0p" />
          <p className="mt-4 text-center font-display text-lg tracking-[0.12em] text-brand-olive" data-id="element-77" data-mp="l1s1pjyygryp">NANCY URIBE</p>
          <p className="text-center text-sm text-ink/60" data-id="element-78" data-mp="g4rv97y71n72">Creator of The Aroma Lab™</p>
        </div>

        <div data-id="element-79" data-mp="3gcjftziz1gsj">
          <p className="font-display text-sm uppercase tracking-[0.2em] text-brand-sage" data-id="element-80" data-mp="3kfy0j3huulcb">Meet your guide</p>
          <h2 className="mt-3 font-serif text-[34px] font-bold leading-tight text-ink md:text-5xl" data-id="element-81" data-mp="3pfaue8758soe">Hi, I'm Nancy Uribe</h2>
          <div className="mt-5 space-y-4 text-[17px] leading-relaxed text-ink/85" data-id="element-82" data-mp="3u6swizkwkzay">
            <p data-id="element-83" data-mp="2zzll40b5lt8">And I want to tell you why I created this.</p>
            <p data-id="element-84" data-mp="31kiv1e0bius">
              I've seen so many creative people who want to develop their own aromatic products… but they get stuck in the
              same cycle:
            </p>
          </div>
          <ul className="mt-4 grid grid-cols-2 gap-2" data-id="element-85" data-mp="by1rnxywf4nd">
            {cycle.map(c => <li key={c} className="rounded-xl bg-cream px-3 py-2.5 text-[15px] text-ink/80" data-id="element-86" data-mp="gyg0hi8bqimg">
                {c}
              </li>)}
          </ul>
          <div className="mt-5 space-y-4 text-[17px] leading-relaxed text-ink/85" data-id="element-87" data-mp="2ipsx7k051k7f">
            <p data-id="element-88" data-mp="3m0zz98ytlx9x">
              And eventually they wonder:{" "}
              <strong className="font-serif text-lg italic text-brand-olive" data-id="element-89" data-mp="3m3m779pmieso">
                “How do I actually create something that feels like mine?”
              </strong>
            </p>
            <p data-id="element-90" data-mp="3v03h69m946mu">
              That question is what inspired The Aroma Lab™. Recipes can tell you what to make — but they don't teach you
              how to think about creating something new. I wanted a framework you could return to whenever inspiration
              strikes.
            </p>
          </div>

          <ol className="mt-6 flex flex-col items-center gap-1.5 rounded-2xl bg-brand-mist py-5" data-id="element-91" data-mp="3u2d4l0pedap">
            {flowSteps.map((s, i) => <li key={s} className="flex flex-col items-center gap-1.5" data-id="element-92" data-mp="dlg9ijxcywzm" data-mpi={i}>
                <span className="font-display text-lg uppercase tracking-[0.16em] text-brand-olive" data-id="element-93" data-mp="rl7u53idrbml">{s}</span>
                {i < flowSteps.length - 1 && <ArrowDownIcon className="h-4 w-4 text-brand-sage" aria-hidden="true" data-id="element-94" data-mp="mnphp355me9u" />}
              </li>)}
          </ol>

          <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-ink/85" data-id="element-95" data-mp="1663ltmqa8yje">
            <p data-id="element-96" data-mp="1b6hsb0c8k0fb">
              That's why I call it The Aroma Lab. I want you to experiment. To test. To document. To discover combinations
              you love. And eventually… to have products you can genuinely call your own.
            </p>
            <p data-id="element-97" data-mp="nhygwbxw37j0">I'm excited to have you inside.</p>
          </div>
          <p className="mt-4 font-serif text-3xl italic text-brand-olive" data-id="element-98" data-mp="nflunml3mb05">Nancy Uribe</p>

          <div className="mt-8" data-id="element-99" data-mp="s9q1m5ud6j18">
            <CtaButton label="I Want to Create With Nancy" data-id="element-100" data-mp="djr5e8mddhoe" />
          </div>
        </div>
      </div>
    </section>;
}